import { render, staticRenderFns } from "./BarChartVerbrauch.vue?vue&type=template&id=1ce73162&"
import script from "./BarChartVerbrauch.vue?vue&type=script&lang=js&"
export * from "./BarChartVerbrauch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports